export default __webpack_public_path__ + "static/media/time-light.4f2226e5.svg";